import LocalPharmacyRoundedIcon from '@mui/icons-material/LocalPharmacyRounded';
import QrCodeScannerRoundedIcon from '@mui/icons-material/QrCodeScannerRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import { lazy } from 'react';
import { PERMISSIONS } from '@/api/permissions';
import { paths } from '@/routes/paths';
import { RequirePermission } from '@/routes/guards';
import type { ModuleManifest } from './manifest';

const PharmacyPage = lazy(() => import('@/features/pharmacy/PharmacyPage'));
const DispensesPage = lazy(() => import('@/features/pharmacy/DispensesPage'));

/**
 * The counter: scan a prescription's QR code and hand over. Deliberately its
 * own module although it is one screen — a dispensing organization holds
 * PRESCRIPTION_DISPENSE and nothing clinical, so without it a pharmacy would
 * open the console on a grid with no door.
 */
export const pharmacyModule: ModuleManifest = {
  key: 'pharmacy',
  titleKey: 'modules.pharmacy.title',
  descriptionKey: 'modules.pharmacy.description',
  icon: LocalPharmacyRoundedIcon,
  prefix: paths.pharmacy,
  anyOf: [PERMISSIONS.PRESCRIPTION_DISPENSE],
  sections: [
    {
      key: 'pharmacy',
      items: [
        {
          key: 'pharmacy',
          labelKey: 'nav.pharmacy',
          to: paths.pharmacy,
          icon: <QrCodeScannerRoundedIcon />,
          anyOf: [PERMISSIONS.PRESCRIPTION_DISPENSE],
        },
        {
          // What this pharmacy has dispensed; platform staff read every fill.
          key: 'dispenses',
          labelKey: 'dispenses.nav',
          to: paths.dispenses,
          icon: <ReceiptLongRoundedIcon />,
          anyOf: [PERMISSIONS.PRESCRIPTION_DISPENSE],
        },
      ],
    },
  ],
  routes: [
    {
      element: <RequirePermission permission={[PERMISSIONS.PRESCRIPTION_DISPENSE]} />,
      children: [
        { path: paths.pharmacy, element: <PharmacyPage /> },
        { path: paths.dispenses, element: <DispensesPage /> },
      ],
    },
  ],
  landing: () => paths.pharmacy,
};
